import * as yup from 'yup';

import type { Announcement } from '../types';

export const announcementCreateSchema = yup.object({
  title: yup
    .string()
    .required('Announcement title is required')
    .min(3, 'Title must be at least 3 characters')
    .max(200, 'Title must be no more than 200 characters'),
  
  content: yup
    .string()
    .required('Announcement content is required')
    .min(10, 'Content must be at least 10 characters')
    .max(5000, 'Content must be no more than 5000 characters'),
  
  summary: yup
    .string()
    .max(500, 'Summary must be no more than 500 characters'),
  
  type: yup
    .mixed<Announcement['type']>()
    .required('Announcement type is required')
    .oneOf(['general', 'emergency', 'event', 'academic', 'policy', 'reminder'], 'Invalid announcement type'),
  
  priority: yup
    .mixed<Announcement['priority']>()
    .required('Priority level is required')
    .oneOf(['low', 'medium', 'high', 'critical'], 'Invalid priority level'),
  
  target_roles: yup
    .array()
    .of(yup.string().defined())
    .min(1, 'At least one target role must be selected')
    .required('Target roles are required'),
  
  target_grades: yup
    .array()
    .of(yup.string().defined()),
  
  channels: yup
    .array()
    .of(yup.string().defined())
    .min(1, 'At least one delivery channel must be selected')
    .required('Delivery channels are required'),
  
  scheduled_for: yup
    .string()
    .test('future-date', 'Scheduled date must be in the future', function(value) {
      if (!value) return true; // Allow null/empty for immediate sending
      const scheduledDate = new Date(value);
      const now = new Date();
      return scheduledDate > now;
    }),
  
  expires_at: yup
    .string()
    .test('future-date', 'Expiration date must be in the future', function(value) {
      if (!value) return true; // Allow null/empty
      const expirationDate = new Date(value);
      const now = new Date();
      return expirationDate > now;
    }),
  
  school_id: yup
    .string(),
  
  tags: yup
    .array()
    .of(yup.string().defined()),
});

export const announcementUpdateSchema = yup.object({
  title: yup
    .string()
    .min(3, 'Title must be at least 3 characters')
    .max(200, 'Title must be no more than 200 characters'),
  
  content: yup
    .string()
    .min(10, 'Content must be at least 10 characters')
    .max(5000, 'Content must be no more than 5000 characters'),
  
  summary: yup
    .string()
    .max(500, 'Summary must be no more than 500 characters'),
  
  type: yup
    .mixed<Announcement['type']>()
    .oneOf(['general', 'emergency', 'event', 'academic', 'policy', 'reminder'], 'Invalid announcement type'),
  
  priority: yup
    .mixed<Announcement['priority']>()
    .oneOf(['low', 'medium', 'high', 'critical'], 'Invalid priority level'),
  
  target_roles: yup
    .array()
    .of(yup.string().defined())
    .min(1, 'At least one target role must be selected'),
  
  target_grades: yup
    .array()
    .of(yup.string().defined()),
  
  channels: yup
    .array()
    .of(yup.string().defined())
    .min(1, 'At least one delivery channel must be selected'),
  
  scheduled_for: yup
    .string()
    .test('future-date', 'Scheduled date must be in the future', function(value) {
      if (!value) return true; // Allow null/empty for immediate sending
      const scheduledDate = new Date(value);
      const now = new Date();
      return scheduledDate > now;
    }),
  
  expires_at: yup
    .string()
    .test('future-date', 'Expiration date must be in the future', function(value) {
      if (!value) return true; // Allow null/empty
      const expirationDate = new Date(value);
      const now = new Date();
      return expirationDate > now;
    }),
  
  school_id: yup
    .string(),
  
  tags: yup
    .array()
    .of(yup.string().defined()),
});
